import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { SmartConfigInstruction } from 'console/smart-config/components/instruction';
import { SmartConfigSending } from 'console/smart-config/components/sending';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { ColumnBox } from 'shared/components/containers';
import { motion } from 'framer-motion';
import { Button } from '@mui/material';
const pageVariants = {
    initial: {
        opacity: 0,
    },
    in: {
        opacity: 1,
    },
    out: {
        opacity: 0,
    },
};
const page_transition = {
    type: 'tween',
    ease: 'linear',
    duration: 0.3,
    delay: 0.1,
};
export const SmartConfigForm = memo(function SmartConfigForm(props) {
    const { open, onFinish } = props;
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [show, noSecond, showSecond] = useBooleanState(false);
    const onSend = useCallback((name, password) => {
        setName(name);
        setPassword(password);
        showSecond();
    }, []);
    if (!open) {
        return null;
    }
    return (_jsx(motion.div, { initial: "initial", animate: "in", variants: pageVariants, transition: page_transition, children: _jsxs(ColumnBox, { children: [!show && (_jsx(SmartConfigInstruction, { name: name, password: password, onSend: onSend, onCancel: onFinish })), show && (_jsx(SmartConfigSending, { name: name, password: password, onCancel: noSecond })), _jsx(Button, { color: "info", variant: "outlined", onClick: onFinish, children: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C" })] }) }, "wifi-box"));
});
